module.exports = __webpack_public_path__ + "df03ac73c5d9b7e368406ed492e8adab.jpg";